<template>

	<v-row class="mt-4 pl-0 ml-n6 mb-n3" style="margin-right: -2px;">
		<v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="px-3 pt-0 pb-0">
			<v-text-field
				class="ml-3 mr-n2 mt-2"
				label="Default value"
				v-model="field.typeProperties.defaultValue"
				:rules="agile.fieldRules.nameRules"
				outlined
				dense
			></v-text-field>
		</v-col>
	</v-row>

</template>


<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from "@/shift/agile";
import fb from '@/shift/fb';


export default
{
	name: 'ViewIntegerField',

	props:
	{
		id: { type: String },
		field: { type: Object },
	},

	data: () =>
	({
		
	

	}),



	computed:
	{
		agile()
		{
			return agile;
		},
		
		routeKey()
		{
			return this.$route.params.key;
		},
	},



	created()
	{
		fb;

	},

	mounted()
	{
		
	},

	methods:
	{
		
	}

}

</script>

